import { createMaintenanceAttachmentActions } from '@hkm/shared/domain/maintenanceAttachment/uploadAttachement/maintenanceUploadAttachmentActionsFactory';

export const uploadAttachmentActionsSet = createMaintenanceAttachmentActions('maintenance/attachment');
export const uploadAttendantAttachmentActionsSet = createMaintenanceAttachmentActions('attendant/maintenance/attachment');



// WEBPACK FOOTER //
// ./src/components/shared/Templates/Maintenance/MaintenanceAttachmentsTile/domain/actions.ts